import React from 'react'
import { createRoot, Root } from 'react-dom/client'
import 'whatwg-fetch'
import './i18next/i18n'

import App from './app/App'
import { initTracking } from './tracking/tracking'
import configureStore from './redux/store/configureStore'
import ErrorBoundary from './components/common/containers/errorBoundary/ErrorBoundary'

import '/src/index.css'
import './googleTranslateHack'

initTracking()
const store = configureStore

const container = document.getElementById('root')
const root: Root = createRoot(container!)

root.render(
  <ErrorBoundary>
    <App store={store} />
  </ErrorBoundary>
)
